<template>
    <div class="ppv2-flex ppv2-items-center ppv2-gap-2">
        <!-- Left Icon -->
        <slot name="icon">
            <span v-if="iconLeft" v-html="iconLeft" class="ppv2-flex-shrink-0"></span>
        </slot>
        <slot name="label-icon"></slot>

        <!-- Label Text (normal) -->
        <label
            v-if="label && !link"
            :for="computedId"
            class="ppv2-text-black"
            :class="customClass || ['ppv2-block', 'poppinsMedium']"
            :style="[customLabelStyle, { fontSize: normalizeFontSize(customSizeLabel, true) }]"
        >
            {{ label }}<span v-if="required" class="ppv2-text-[#7D2DBD]">*</span>
            <span v-if="tooltipMsg != ''" data-tooltip data-tooltip-right :data-tooltip-message="tooltipMsg">
                <i class="fas fa-info-circle"></i>
            </span>
        </label>

        <!-- Label as Link with same color -->
        <a
            v-if="label && link"
            :href="link"
            target="_blank"
            rel="noopener noreferrer"
            class="ppv2-block poppinsSemiBold ppv2-text-black ppv2-text-opacity-90 hover:ppv2-underline"
            :style="[customLabelStyle, { fontSize: normalizeFontSize(customSizeLabel, true) }]"
        >
            {{ label }}<span v-if="required" class="ppv2-text-[#7D2DBD]">*</span>
        </a>

        <!-- Right Icon -->
        <span v-if="iconRight" v-html="iconRight" class="ppv2-flex-shrink-0 ppv2-text-black"></span>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'BaseLabel',
    methods: {
        normalizeFontSize,
    },
    props: {
        label: {
            type: String,
            required: false,
        },
        customSizeLabel: {
            type: Number,
            default: 15,
        },
        customLabelStyle: String,
        forId: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        iconLeft: {
            type: String,
            required: false,
        },
        iconRight: {
            type: String,
            required: false,
        },
        customClass: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            required: false,
        },
        tooltipMsg: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            generatedId: `label-${Math.random().toString(36).substr(2, 9)}`,
        }
    },
    computed: {
        computedId() {
            return this.forId || this.generatedId
        },
    },
}
</script>

<style scoped></style>
